import { render, staticRenderFns } from "./EditarDiagnostico.vue?vue&type=template&id=09df9a32&scoped=true"
import script from "./EditarDiagnostico.vue?vue&type=script&lang=js"
export * from "./EditarDiagnostico.vue?vue&type=script&lang=js"
import style0 from "./EditarDiagnostico.vue?vue&type=style&index=0&id=09df9a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09df9a32",
  null
  
)

export default component.exports